import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RentAmountModel } from './rent-amount.model';
import { AmenityModel } from './amenity.model';
import { CodeDescriptionModel } from '../../../models/code-description.model';
import { ApartmentModel } from '../../../models/apartment.model';
import { TenantInfoModel } from './tenant-info.model';
import { PartyModel } from '../../../models/party.model';

export class ApartmentInfoModel {
    apartmentId: string = null;
    apartmentDesignation: string = null;
    addressId: string = null;
    fullAddress: string = null;

    effectiveTo: Date = null;

    rentAmount: RentAmountModel = null;
    legalRegulatedRent: RentAmountModel = null;
    actualRentPaid: RentAmountModel = null;

    registrationReason: CodeDescriptionModel = null;
    temporaryExemptStatuses: CodeDescriptionModel[] = [];
    permanentExemptStatus: CodeDescriptionModel = null;

    previouslyAffectedApartment: boolean = null; // need to check one more time
    previouslyAffectedApartments: ApartmentModel[] = [];

    reasonForDifferences: CodeDescriptionModel[] = [];
    marketRateTypes: CodeDescriptionModel[] = [];

    registrationReasonAdditionalInfo: string = null;
    otherRentDifferenceReason: string = null;
    otherPermanentExemptStatusDescription: string = null;

    etpaStatus: string = null;
    registrationApartmentStatus: CodeDescriptionModel = null;
    areaOfMedianIncome: number = null;
    notForProfit: string = null;

    registrationDate: Date = null;
    rentControlDate: Date = null;
    stabilizedDate: Date = null;

    mcrAmount: number = null;
    mbrAmount: number = null;
    rooms: number = null;

    isVacant: boolean = null;
    hasFiledIAINotification: boolean = null;

    apartmentServices: AmenityModel [] = [];
    tenants: TenantInfoModel [] = [];
    owners: PartyModel [] = [];

    registrationType: CodeDescriptionModel = null;
    legalRegulatedRentTotal: number = null;
// end of all models.

constructor(model?: Partial<ApartmentInfoModel>) {
    if (model && model !== undefined) {
      const def = new ApartmentInfoModel();
      Object.keys(def).forEach((key: string) => {
        this[key] = model[key] !== null && model[key] !== undefined ?
          model[key] : def[key];
      });
    }
  }

  // to set the values coming from API.
  public static generateForm(fb: FormBuilder, model?: ApartmentInfoModel): FormGroup {
    const form = ApartmentInfoModel.asForm(fb);
    if (model && model !== undefined) {
      form.setValue(model);
    }
    return form;
  }

  // create formGroup here.
  public static asForm(fb: FormBuilder): FormGroup {
    return fb.group({
      apartmentId: [''],
      apartmentDesignation: ['', Validators.required],
      addressId: ['', Validators.required],
      fullAddress: [''],

      effectiveTo: [''],

      rentAmount: ['', [Validators.min(0.00), Validators.max(20000.00)]],
      legalRegulatedRent: ['', [Validators.min(0.00), Validators.max(20000.00)]],
      // ['', [Validators.min(0.00), Validators.max(20000.00)]],
      actualRentPaid: ['', [Validators.min(0.00), Validators.max(20000.00)]],

      registrationReason: ['', Validators.required],
      temporaryExemptStatuses: [''],
      permanentExemptStatus: [''],

      previouslyAffectedApartment: [''],
      previouslyAffectedApartments: [''],

      reasonForDifferences: [''],
      marketRateTypes: [''],

      registrationReasonAdditionalInfo: [''],
      otherRentDifferenceReason: [''],
      otherPermanentExemptStatusDescription: [''],

      etpaStatus: [''],
      registrationApartmentStatus: ['', Validators.required],
      areaOfMedianIncome: [''],
      notForProfit: [''],

      registrationDate: ['', Validators.required],
      rentControlDate: [''],
      stabilizedDate: [''],

      mcrAmount: [''],
      mbrAmount: [''],
      rooms: ['', [Validators.required, Validators.min(0), Validators.max(200)]],

      isVacant: [''],
      hasFiledIAINotification: [''],

      apartmentServices: [],
      tenants: [],
      owners: [],
      legalRegulatedRentTotal: [''],
      registrationType: ['']
    });
  }

  public static asModel(form: FormGroup): ApartmentInfoModel {
    const model = new ApartmentInfoModel(form.getRawValue());
    return model;
  }
}
